<template>
  <div class="validation-token">
    <div class="validation-token__summary">
      <div class="validation-token__icon icon-circle">
        <AttendantSvg class="validation-token--hospital" />
      </div>

      <div class="validation-token__message">
        <h2>Realize a validação do token no guichê de atendimento</h2>
        <p>
          Vamos utilizar as informações preenchidas <br />
          anteriormente para adiantar seu <br />
          atendimento no guichê.
        </p>
      </div>
    </div>

    <VNavButton
      variant="primary"
      text="Continuar"
      @click.native="goToQuestions"
      class="validation-token__actions"
    />
  </div>
</template>

<script>
import VNavButton from '@/components/commons/VNavButton.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'ValidationDenied',
  components: {
    VNavButton,
  },
  data: () => ({
    isIconResultVisible: false,
  }),
  computed: {
    ...mapState({
      admission: ({ currentAdmission }) => currentAdmission.data,
    }),
    ...mapGetters({
      isScheduledAdmission: 'global/isScheduledAdmission',
      isVaccineFlow: 'global/isVaccineFlow',
    }),
  },

  async created() {
    this.showIconResult();
    await this.getAdmissionById(this.admission.id);
  },
  methods: {
    ...mapActions(['global/updateFlowSteps', 'getAdmissionById', 'global/skipServiceDeskFlowFail']),
    showIconResult() {
      setTimeout(() => {
        this.isIconResultVisible = true;
      }, 500);
    },
    goToQuestions() {
      this['global/skipServiceDeskFlowFail'](true);
      return this.goNextStep('questions_conclusion_step');
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-token {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  align-items: center;
  width: 100%;

  &__summary {
    margin-bottom: 45px;
  }

  &__message {
    h2 {
      font-weight: 700;
      font-size: 24px;
      line-height: 133%;
      text-align: center;
      max-width: 328px;
    }

    p {
      margin: 16px auto 0;
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      text-align: center;
      max-width: 313px;
    }
  }

  &__icon {
    margin: 0 auto 24px;

    & svg {
      width: 35px;
      path {
        fill: #0037ff;
      }
    }
  }

  &__actions {
    position: absolute;
    bottom: 8px;
  }
}
</style>
